export default "__VITE_PUBLIC_ASSET__48af03a0__"